export function getUploadPurposeOptions(t) {
  return [
    { title: t('upload.feedback.purpose.personal'), value: 'personal' },
    { title: t('upload.feedback.purpose.professional'), value: 'professional' },
    { title: t('upload.feedback.purpose.client'), value: 'client' },
    { title: t('upload.feedback.purpose.other'), value: 'other' },
  ];
}

export function buildUploadFeedbackPayload(feedback, selectedPurpose) {
  const purposeValue =
    typeof selectedPurpose === 'string'
      ? selectedPurpose
      : selectedPurpose?.value || '';

  return {
    expectations: feedback?.expectations?.trim() || '',
    purpose: purposeValue,
  };
}
